import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GoogleLoginButton from './GoogleLoginButton';
import vwzLogo from '../assets/vwz-logo.png';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-battle-dark/90 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src={vwzLogo}
                alt="Verbal Warzone logo"
                className="h-10 w-auto shrink-0"
                data-testid="navbar-logo"
              />
              <span className="text-white text-xl font-black uppercase tracking-tight">
                VERBAL <span className="text-brand-yellow" style={{textShadow: '0 0 20px rgba(245,230,66,0.45)'}}>WARZONE</span>
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/browse" className="text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide">
              Browse Battles
            </Link>
            <Link to="/rankings" className="text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide">
              Rankings
            </Link>

            {user ? (
              <>
                <Link to="/profile" className="text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide">
                  My Profile
                </Link>
                {isAdmin() && (
                  <Link to="/admin" className="text-gray-400 hover:text-battle-red transition-colors text-sm font-semibold uppercase tracking-wide">
                    Admin
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className="btn-secondary py-2 px-4 text-sm"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide"
                  data-testid="navbar-sign-in-link"
                >
                  Sign in
                </Link>
                <GoogleLoginButton id="googleSignInButtonDesktop" />
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="text-gray-400 hover:text-white transition-colors"
              data-testid="mobile-menu-button"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {showMobileMenu ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {showMobileMenu && (
          <div className="md:hidden pb-4 border-t border-gray-800 mt-2 pt-4">
            <Link
              to="/browse"
              className="block py-2 text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide"
              onClick={() => setShowMobileMenu(false)}
            >
              Browse Battles
            </Link>
            <Link
              to="/rankings"
              className="block py-2 text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide"
              onClick={() => setShowMobileMenu(false)}
            >
              Rankings
            </Link>
            {user ? (
              <>
                <Link
                  to="/profile"
                  className="block py-2 text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide"
                  onClick={() => setShowMobileMenu(false)}
                >
                  My Profile
                </Link>
                {isAdmin() && (
                  <Link
                    to="/admin"
                    className="block py-2 text-gray-400 hover:text-battle-red transition-colors text-sm font-semibold uppercase tracking-wide"
                    onClick={() => setShowMobileMenu(false)}
                  >
                    Admin
                  </Link>
                )}
                <button
                  onClick={() => {
                    handleLogout();
                    setShowMobileMenu(false);
                  }}
                  className="block py-2 text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide"
                >
                  Logout
                </button>
              </>
            ) : (
              <div className="py-2 space-y-2">
                <Link
                  to="/login"
                  className="block py-2 text-gray-400 hover:text-white transition-colors text-sm font-medium uppercase tracking-wide"
                  onClick={() => setShowMobileMenu(false)}
                  data-testid="navbar-sign-in-link-mobile"
                >
                  Sign in
                </Link>
                <GoogleLoginButton id="googleSignInButtonMobile" />
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
